import React from 'react';
import PropTypes from 'prop-types';
import { goHome } from '@/utils/Common/Redirects';

// import components
import Button from '@/components/atoms/Button';

const WishlistEmpty = ({ subtitle, paragraph, ctaText }) => (
  <>
    <h2 className='dln-wishlist__subtitle'>{subtitle}</h2>
    <p className='dln-wishlist__paragraph'>{paragraph}</p>
    <div className='dln-wishlist__foot dln-wishlist__foot--divider'>
      <Button onClick={goHome} text={ctaText} />
    </div>
  </>
);

WishlistEmpty.propTypes = {
  subtitle: PropTypes.string.isRequired,
  paragraph: PropTypes.string.isRequired,
  ctaText: PropTypes.string.isRequired,
};

export default WishlistEmpty;
